import { Component, computed, inject, input } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { APPLICATION_TYPE, FeatureFlagPipe } from '@core';
import { type ChildRelationDevices, DeviceAttributeType } from '@devices';
import { type IncidentsScope, IncidentsScopedTableComponent } from '@incidents';

import { MeasurementUnitDisplayPipe } from '../../pipes';
import { DeviceAttributesComponent } from '../device-attributes';
import { DeviceStatsChartComponent } from '../device-stats-chart/device-stats-chart.component';
import { SwitchPduChildrenTableComponent } from '../switch-pdu-children-table';

@Component({
  imports: [
    MatCard,
    MatCardContent,
    MatCardTitle,
    SwitchPduChildrenTableComponent,
    IncidentsScopedTableComponent,
    DeviceStatsChartComponent,
    MeasurementUnitDisplayPipe,
    FeatureFlagPipe,
    DeviceAttributesComponent,
  ],
  selector: 'avs-switch-pdu-child-details',
  styles: [`
    .port-details-units {
      color: var(--gray-700);
    }
  `],
  templateUrl: './switch-pdu-child-details.component.html',
})
export class SwitchPduChildDetailsComponent {
  port = input.required<ChildRelationDevices>();
  locationId = input.required<string>();
  parentId = input.required<string>();
  isNetworkSwitch = input.required<boolean>();

  protected readonly incidentColumns = ['status', 'reported'];
  protected isMobile = inject(APPLICATION_TYPE) === 'mobile';
  protected realtimeAttributes = computed(() => this.port().childDevice.additionalAttributes
    .filter(attr => attr.attributeType === DeviceAttributeType.REALTIME),
  );
  protected incidentsScope = computed<IncidentsScope>(() => ({ deviceId: this.port().childDevice.id }));
}
